import "./FldDefEdit";

import { useState } from "react";
import { wgtSettings } from "../widgets";
import { randomUUID } from "../../axios_with_token";
import { widgets, getEditWgt } from "../widgets";
import { useForm } from "react-hook-form";

// get Component for inputs of settings of fld input
// [] fldName, path include fldName already, like [root,inputsettings,fldName]
export function FldDefEdit({fldName, fldDef, fldVal, form:formIn, defaultSettings, forms, path:pathIn}){

    // const formLocal = useForm();
    // const form = formIn || formLocal;
    // if(forms && pathIn){
    //     forms[pathIn] = form;
    // }

    // if((form === formLocal) && fldVal){
    //     // console.log('form.setValue(path, fldVal):', path, fldVal);
    //     form.setValue(path, fldVal);
    // }

    const [type, setType] = useState(fldDef.type||'input');
    // [] template
    const fldWgtSettings = {
        ...defaultSettings||{},
        ...wgtSettings[type] || {}
    };
    
    // typeform
    const typePath = [pathIn, 'type'].join(',');
    const formType = useForm();
    forms[typePath] = formType;
    const {onChange:regedOnTypeChange, ...regedTypeRest} = formType.register(typePath);
    formType.setValue(typePath, type);
    
    const id = `flddefedit-${randomUUID()}`;
    return <>
        <div 
            key={fldName}
            className="row mb-3"
        >
            {/* <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">{fldDef.caption || fldName}</label> */}
            <div className="col-sm-2 col-form-label p-0 m-0">
                <div 
                    className="row m-0 p-0"
                >
                    <label htmlFor="inputEmail3" className="col-sm-2 col-form-label">type</label>
                    <div className="col-sm-10">
                        <select type="text" className="form-control form-control-sm"
                            defaultValue={type}
                            onChange={evt=>{
                                console.log('set type to', evt.target.value);
                                regedOnTypeChange(evt);
                                setType(evt.target.value);
                            }}
                            {...regedTypeRest}
                        >
                            {Object.keys(widgets).map(wgtName=><option
                                key={wgtName}
                                value={wgtName}
                            >
                                {wgtName}
                            </option>)}
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-sm-10">
                <div 
                    className="row m-0 p-0"
                >
                    {Object.keys(fldWgtSettings).map(fldWgtSettingName=>{
                        const subId=`${id}-${fldWgtSettingName}`;
                        const fldWgtSettingDef = fldWgtSettings[fldWgtSettingName];
                        const SettingsWgt = getEditWgt(fldWgtSettingDef['type'] || 'input');
                        const fldWgtSettingsVal = (fldDef||{})[fldWgtSettingName];
                        console.log('...fldWgtSettingsVal:', fldWgtSettingsVal, fldWgtSettingName, fldDef, fldVal)
                        const path = [pathIn, fldWgtSettingName].join(',');
                        return <div key={subId} className="row">
                            <label htmlFor={subId} className="col-sm-2 col-form-label"
                                title={fldWgtSettingName}
                            >{fldWgtSettingName}</label>
                            <div className="col-sm-10">
                                <SettingsWgt
                                    // [note] fldName and path are same. for old widget, use fldName, for objEdit, arrEdit, use path,
                                    // [todo] different interface, considering make them same
                                    // form={form}
                                    fldName={path}
                                    fldDef={fldWgtSettingDef}

                                    fldVal={fldWgtSettingsVal}
                                    objVal={fldWgtSettingsVal}

                                    forms={forms}
                                    path={path}
                                ></SettingsWgt>
                            </div>
                        </div>;
                    })}
                </div>                
            </div>
        </div>
    </>
}


// [] use helper could be used for async, choose ...
export default function useFldDefEdit({tblDef, form, defaultSettings}){
    const components = {};
    const inputSettings = tblDef.inputSettings||{}
    Object.keys(inputSettings).forEach(fldName=>{
        const fldDef = inputSettings[fldName] || {};
        components[fldName] = ({})=><FldDefEdit
            fldName={fldName}
            fldDef={fldDef}
            form={form}
            defaultSettings={{
                caption:{},
                default:{},
                ...(defaultSettings||{})
            }}
        ></FldDefEdit>
    });

    return {
        components
    }
}
